import { useEffect, useState } from "react";
import { getBatches } from "../services/campaignMeta.api";

export default function BatchDropdown({ onSelect }) {

  const [batches, setBatches] = useState([]);

  useEffect(() => {
    fetchBatches();
  }, []);

  async function fetchBatches() {
    const res = await getBatches();
    setBatches(res.data);
  }

  return (
    <div>
      <label>Select Batch</label>

      <select onChange={(e) => onSelect(Number(e.target.value))}>
        <option value="">Select Batch</option>

        {batches.map(batch => (
          <option key={batch.id} value={batch.id}>
            {batch.name} ({batch.activeStudents} students)
          </option>
        ))}
      </select>
    </div>
  );
}
